'use strict';

const AnnotationDialogDirective = () => {

  return {
    scope: true,
    bindToController: true,
    controller: 'AnnotationDialogController',
    controllerAs: 'vm',
    link: () => {},
    templateUrl: 'dash/nav/navLeft/annotations/dialog/annotationDialog.tpl.html'
  };
};

module.exports = AnnotationDialogDirective;


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/annotations/dialog/AnnotationDialogDirective.js